<div class="close-icon">
  <img src="../../../assets/icon/close-icon.svg" alt="" (click)="close()" />
</div>
<div class="no-scrollbar keyboard-off container">
  <div class="forgot-pass-wrap">
    <div  class="ion-align-self-center height20">
      <!--Key Image Section-->
      @if (!loginWithMsn) {
        <img class="key-logo" src="../../../assets/icon/key_logo.png" alt="key" />
      }
    </div>
    <div class="height20">
      <h3 class="forgot-pass-text">{{(loginWithMsn ? 'forgot-password.Login-msn' : 'forgot-password.Forgot') | translate}}</h3>
      <h3 class="forgot-text" [innerHTML]="'forgot-password.reset-text'| translate"></h3>
    </div>
    <div class="height10"></div>
    <div  class="input-section height20">
      <ion-grid class="ion-no-padding">
        <ion-row  class="ion-no-padding ion-justify-content-center">
          <ion-col size="8" class="ion-no-padding segment-col">
          <div class="custom-segment"
            role="radiogroup"
            aria-label="Select recovery method"
          >
            <button class="custom-segment-button"
              role="radio"
              type="button"
              [class.active]="selectedOption() === 'sms'"
              [attr.aria-checked]="selectedOption() === 'sms'"
              tabindex="0"
              (click)="onOptionChange('sms')"
            >
              {{'forgot-password.via-msn-text' | translate }}
            </button>
            <button
              class="custom-segment-button"
              role="radio"
              type="button"
              [class.active]="selectedOption() === 'email'"
              [attr.aria-checked]="selectedOption() === 'email'"
              tabindex="-1"
              (click)="onOptionChange('email')"
            >
              {{'forgot-password.via-mail-text' | translate }}
            </button>
          </div>
          </ion-col>
        </ion-row>
        @if (isSmsSelected()) {
          <ion-row>
            <ion-col size="3.2" class="ion-no-padding">
              <ion-item class="ion-no-padding" lines="none">
                <ion-input [value]="dialCode" type="tel" class="login-phone-number" min="1" maxlength="4" placeholder="+44"
                (input)="checkInput($event)" (keypress)="numericOnly($event)"></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="0.3" class="ion-no-padding"></ion-col>
            <ion-col size="8.5" class="ion-no-padding">
              <ion-item id="border-custom" class="ion-no-padding" lines="none">
                <input [(ngModel)]="msn" type="tel" #phoneNumber placeholder="{{ 'mobile-number-update.Mobile' | translate }}"
                  maxlength="11" accesskey="p" (keypress)="numericOnly($event)" (input)="getPhoneNumber($event)"
                  class="password-alignment login-phone-number" />
                </ion-item>
              </ion-col>
            </ion-row>
        } 
        @if (!isSmsSelected()) {
          <ion-row>
            <ion-col  class="ion-no-padding">
              <ion-item id="border-custom-2" class="ion-no-padding" lines="none">
                <input [(ngModel)]="email" type="email" #emailInput placeholder="{{ 'email-update.email-placeholder' | translate }}"
                maxlength="50" accesskey="e" (input)="getEmail($event)"
                class="password-alignment login-phone-number" />
                </ion-item>
              </ion-col>
            </ion-row>
        }           
        </ion-grid>
        @if (isSmsSelected()) {
          <h1 class="text-hint">{{(isSmsSelected() ? 'forgot-password.Login-msn-text' : 'forgot-password.verification') | translate}}</h1>
        } @else if (!isSmsSelected()) {
          <h1 class="text-hint">{{(!isSmsSelected() ? 'forgot-password.Login-email-text' : 'forgot-password.verification') | translate}}</h1>
          @if (this.isEmailInvalid() && isEmailEmpty()) {
            <div class="errorContainer">
              <ion-icon name="warning" class="icon"></ion-icon>
                <span class="text">{{'forgot-password.email-warning' | translate}}</span>
            </div>
          }
        }
        @if (isNumberInvalid && isSmsSelected()) {
          <div class="errorContainer">
            <ion-icon name="warning" class="icon"></ion-icon>
            @if (phoneInValid) {
              <span class="text">{{'forgot-password.Please' | translate}}</span>
            }
            @if (!phoneInValid) {
              <span class="text">{{'forgot-password.mobile' | translate}}</span>
            }
          </div>
        }
        <ion-button
          expand="block"
          color="secondary"
          (click)="recoverPassword();startSpinner()"
          [disabled]="isSmsSelected() ? isNumberInvalid || !phoneNumber?.nativeElement?.value?.length || !isOnline : isEmailInvalid() || !isOnline || email?.length === 0"
          class="capsule-btn"
          >@if (!spinnerAnimation && proceed) {
          <span>{{(loginWithMsn ? 'forgot-password.Login-msn-btn' : 'forgot-password.Recover') | translate}}</span>
        }
        @if (spinnerAnimation) {
          <div class="spinners">
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
            </mat-progress-spinner>
          </div>
        }
        @if (!proceed) {
          <mat-icon [@bounceIn] class="tick-mark">
            <svg xmlns="http://www.w3.org/2000/svg" height="60" viewBox="0 96 960 960" width="60"><path d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z"/></svg></mat-icon>
          }
        </ion-button>
      </div>
      <div class="empty-space"></div>
      <div class="ion-align-self-center height20">
        <p class="arrow-back" (click)="dismissDialog()">
          <span class="back">←</span> {{'forgot-password.login' | translate}}
        </p>
      </div>
    </div>
  </div>
